<div class="flex w-full mt-5 pr-2">
  <modus-label class="text-xs grow">{{ translations.blendIntensity.text }}</modus-label>
  <modus-switch
    id="3d-settings-classification-intensity-toggle"
    [formControl]="blendIntensityControl"
  ></modus-switch>
</div>

@if (showIntensitySettings()) {
  <sd-scan-3d-intensity
    [scan3dStyle]="scan3dStyle()"
    (styleChange)="onStyleChange($event)"
    class="mb-2"
  ></sd-scan-3d-intensity>
}
